import { render } from "./Note.vue?vue&type=template&id=4063b330&scoped=true&ts=true"
import script from "./Note.vue?vue&type=script&lang=ts"
export * from "./Note.vue?vue&type=script&lang=ts"

import "./Note.vue?vue&type=style&index=0&id=4063b330&lang=scss&scoped=true"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4063b330"]])

export default __exports__